const gqlDoc = `
  query faqs {
    winefaqlist {
      id
      type
      access
      status
      created
      featured
      title
      body
      category
    }
  }
`

const asyncLoader = ({store, route, rooter}) => {
  if (!route) {
    return Promise.resolve(false)
  }
  let gqlClient = store.getters['getGraphQLClient'](null, gqlDoc)
  const proms = [
    store.dispatch('blob/load', {blobID: `page-blob-top--node-wine-faq-list-header`}),
    store.dispatch('blob/load', {blobID: `page-blob-top--node-wine-faqs-list`}),
    store.dispatch('blob/load', {blobID: `page-blob-bottom--node-wine-faqs-list`})
  ]
  const list = store.getters['list/get']('winefaqs', 'default')
  if (!list) {
    proms.push(
      gqlClient.query({opName: 'faqs'})
        .then(response => {
          if (response && response.data && response.data.winefaqlist) {
            store.dispatch('list/storeList', { view: 'winefaqs', display: 'default', list: Object.values(response.data.winefaqlist) })
            response.data.winefaqlist.forEach(faq => {
              if (faq.id) {
                store.dispatch('node/load', { nid: faq.id })
              }
            })
          }
        })
    )
  }
  return Promise.all(proms)
    .then(() => {
      if (store.getters['blob/isHeader']('page-blob-top--node-wine-faq-list-header')) {
        store.commit('SET_PAGE_SETTING', { key: 'hasHeader', value: true })
      }
    })
}

const pageMixin = {
  computed: {
    faqs() {
      return this.$store.getters['list/get']('winefaqs', 'default') || {}
    }
  }
}

export { pageMixin, asyncLoader }
